import { IncomingOrderStatus } from "~/constants/incomingOrdersStatus"
import { Badge, type BadgeProps } from "~/components/design-system/components"
import { startCase } from "lodash"

interface IncomingOrdersStatusBadgeProps {
  status: IncomingOrderStatus
  size?: BadgeProps["size"]
}

/**
 * Renders a badge for the given incoming order status
 */
export const IncomingOrdersStatusBadge = ({ status, size }: IncomingOrdersStatusBadgeProps) => {
  let badgeVariant = "default"
  if (status === IncomingOrderStatus.Arrived) {
    badgeVariant = "violet"
  }
  if (status === IncomingOrderStatus.OnTime) {
    badgeVariant = "green"
  }
  if (status === IncomingOrderStatus.Delayed) {
    badgeVariant = "red"
  }

  return (
    <Badge variant={badgeVariant as any} size={size}>
      {startCase(status)}
    </Badge>
  )
}
